export const STORAGE_KEYS = {
    WORKSPACE: 'workspace',
} as const;